/* ==========================================================================
   Experten-Beratung – Slider/Drawer-Logik
   - Öffnen/Schließen (Karte, Floating-Widget, Overlay, ESC), Focus-Trap
   - Live-SKU bei Variantenwechsel
   - Allgemeine FAQs live von der FAQ-Seite nachladen
   - Feedback-Versand an ein Google Apps Script
   ========================================================================== */
(function () {
  'use strict';
  if (window.__excoInitialized) return;
  window.__excoInitialized = true;

  var PORTAL_ID = 'ExpertConsultationPortal';
  var SCROLL_LOCK_CLASS = 'overflow-hidden'; // theme-eigene Klasse aus Dawn base.css
  var FAQ_CACHE_KEY = 'exco_faq_cache_v1';
  var FAQ_CACHE_TTL = 10 * 60 * 1000;

  var CARET_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

  var config = { faqUrl: '/pages/haufige-fragen', feedbackEndpoint: '', chatSelector: '', productTitle: '', skuMap: {} };
  // Capture, damit Außen-Klicks zuverlässig zuerst erkannt werden; passive,
  // da nie preventDefault aufgerufen wird → kein Scroll-Blocking auf Touch.
  var OUTSIDE_OPTS = { capture: true, passive: true };
  var portal = null;
  var lastFocused = null;
  var faqLoaded = false;
  var wired = false;
  var skuSynced = false;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function escapeAttr(str) {
    return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  /* --- Konfiguration & Portal ---------------------------------------------- */
  function readConfig() {
    var el = qs('[data-exco-config]');
    if (!el) return;
    try {
      var parsed = JSON.parse(el.textContent);
      if (parsed && typeof parsed === 'object') {
        config.faqUrl = parsed.faqUrl || config.faqUrl;
        config.feedbackEndpoint = parsed.feedbackEndpoint || '';
        config.chatSelector = parsed.chatSelector || '';
        config.productTitle = parsed.productTitle || '';
        config.skuMap = parsed.skuMap || {};
      }
    } catch (e) {
      /* Konfiguration ungültig – Standardwerte bleiben aktiv */
    }
  }

  function buildPortal() {
    var tpl = document.getElementById('ExpertConsultationTemplate');
    if (!tpl || !('content' in tpl)) return null;
    var existing = document.getElementById(PORTAL_ID);
    if (existing) existing.remove();
    var node = document.createElement('div');
    node.id = PORTAL_ID;
    node.appendChild(tpl.content.cloneNode(true));
    document.body.appendChild(node);
    return node;
  }

  /* --- Drawer öffnen / schließen ------------------------------------------- */
  function isOpen() {
    return !!portal && portal.classList.contains('exco-open');
  }

  function openDrawer() {
    if (!portal || isOpen()) return;
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    lastFocused = document.activeElement;
    portal.classList.add('exco-open');
    document.body.classList.add(SCROLL_LOCK_CLASS);
    var drawer = qs('.exco-drawer', portal);
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
    var panel = qs('.exco-drawer__panel', portal);
    if (panel) {
      window.setTimeout(function () {
        try { panel.focus({ preventScroll: true }); } catch (err) { panel.focus(); }
        // Wiederherstellen, falls preventScroll vom Browser ignoriert wurde
        if (window.pageYOffset !== scrollY) window.scrollTo(0, scrollY);
      }, 60);
    }
    // Sofortige Sicherung, falls etwas synchron gescrollt hat
    if (window.pageYOffset !== scrollY) window.scrollTo(0, scrollY);
    document.addEventListener('keydown', onKeydown, true);
    document.addEventListener('mousedown', onOutsideDown, OUTSIDE_OPTS);
    document.addEventListener('touchstart', onOutsideDown, OUTSIDE_OPTS);
    loadGeneralFaq();
  }

  function closeDrawer() {
    if (!portal || !isOpen()) return;
    portal.classList.remove('exco-open');
    document.body.classList.remove(SCROLL_LOCK_CLASS);
    var drawer = qs('.exco-drawer', portal);
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKeydown, true);
    document.removeEventListener('mousedown', onOutsideDown, OUTSIDE_OPTS);
    document.removeEventListener('touchstart', onOutsideDown, OUTSIDE_OPTS);
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus({ preventScroll: true }); } catch (e) {}
    }
    lastFocused = null;
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      closeDrawer();
      return;
    }
    if (e.key === 'Tab') trapFocus(e);
  }

  function trapFocus(e) {
    var panel = qs('.exco-drawer__panel', portal);
    if (!panel) return;
    var focusable = qsa(
      'a[href], button:not([disabled]), textarea, input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])',
      panel
    ).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* --- Klick/Tap außerhalb des Sliders schließt --------------------------- */
  function onOutsideDown(e) {
    if (!portal || !isOpen()) return;
    var panel = qs('.exco-drawer__panel', portal);
    if (panel && panel.contains(e.target)) return;
    closeDrawer();
  }

  /* --- Shopify Inbox Chat öffnen ------------------------------------------- */
  // Öffnet das Chat-Widget, indem sein Auslöser-Button angeklickt wird.
  function openChat() {
    function tryOpen() {
      // Shopify Inbox: Launcher-Button liegt im Shadow-DOM von #ShopifyChat
      var inbox = document.getElementById('ShopifyChat');
      if (inbox && inbox.shadowRoot) {
        var launcher = inbox.shadowRoot.querySelector('button');
        if (launcher) {
          launcher.click();
          return true;
        }
      }
      // Fallback: konfigurierbarer Selektor + allgemeine Heuristiken
      var selectors = [];
      if (config.chatSelector) selectors.push(config.chatSelector);
      selectors.push(
        '#shopify-chat button',
        'button[aria-label*="chat" i]',
        'a[aria-label*="chat" i]',
        '[class*="chat-button" i]'
      );
      for (var i = 0; i < selectors.length; i++) {
        var el = null;
        try {
          el = document.querySelector(selectors[i]);
        } catch (e) {
          el = null;
        }
        if (el) {
          el.click();
          return true;
        }
      }
      return false;
    }

    if (tryOpen()) return;
    // Chat-Widget evtl. noch nicht geladen – kurz nachfassen
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (tryOpen()) {
        window.clearInterval(timer);
      } else if (attempts >= 16) {
        window.clearInterval(timer);
        if (window.console && console.warn) {
          console.warn(
            '[Experten-Beratung] Chat-Widget nicht gefunden. Bitte den CSS-Selektor ' +
            'des Chat-Buttons in den Section-Einstellungen hinterlegen.'
          );
        }
      }
    }, 250);
  }

  /* --- Allgemeine FAQ live nachladen --------------------------------------- */
  function getCachedFaq(url) {
    try {
      var raw = sessionStorage.getItem(FAQ_CACHE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || obj.url !== url || !obj.ts || Date.now() - obj.ts > FAQ_CACHE_TTL) return null;
      return obj.html;
    } catch (e) {
      return null;
    }
  }

  function setCachedFaq(url, html) {
    try {
      sessionStorage.setItem(FAQ_CACHE_KEY, JSON.stringify({ url: url, ts: Date.now(), html: html }));
    } catch (e) {
      /* sessionStorage nicht verfügbar – ohne Cache weiter */
    }
  }

  function loadGeneralFaq() {
    if (faqLoaded || !portal) return;
    faqLoaded = true;
    var target = qs('[data-exco-general-faq]', portal);
    if (!target) return;
    var url = config.faqUrl;

    var cached = getCachedFaq(url);
    if (cached !== null) {
      renderGeneralFaq(target, cached, url);
      return;
    }

    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        setCachedFaq(url, html);
        renderGeneralFaq(target, html, url);
      })
      .catch(function () {
        faqLoaded = false; // erneuter Versuch beim nächsten Öffnen möglich
        showFaqError(target, url, 'Die Fragen konnten nicht geladen werden.');
      });
  }

  function showFaqError(target, url, message) {
    target.innerHTML = '';
    var box = document.createElement('div');
    box.className = 'exco-faq-error';
    box.innerHTML =
      '<p>' + message + '</p>' +
      '<a class="exco-faq-error__link" href="' + escapeAttr(url) + '">Alle Fragen ansehen &rarr;</a>';
    target.appendChild(box);
  }

  function renderGeneralFaq(target, html, url) {
    var groups = extractFaq(html);
    target.innerHTML = '';
    if (!groups.length) {
      showFaqError(target, url, 'Aktuell sind keine allgemeinen Fragen verfügbar.');
      return;
    }
    groups.forEach(function (group) {
      var groupEl = document.createElement('div');
      groupEl.className = 'exco-faq-group';
      if (group.heading) {
        var title = document.createElement('p');
        title.className = 'exco-faq-group__title';
        title.textContent = group.heading;
        groupEl.appendChild(title);
      }
      group.items.forEach(function (item) {
        groupEl.appendChild(buildFaqItem(item.q, item.a));
      });
      target.appendChild(groupEl);
    });
  }

  // Liest die collapsible-content-Sektionen der FAQ-Seite aus.
  function extractFaq(html) {
    var doc;
    try {
      doc = new DOMParser().parseFromString(html, 'text/html');
    } catch (e) {
      return [];
    }
    var groups = [];
    qsa('.collapsible-content', doc).forEach(function (section) {
      var headingEl = section.querySelector('.collapsible-content__heading');
      var heading = headingEl ? headingEl.textContent.trim() : '';
      var items = [];
      qsa('.accordion', section).forEach(function (acc) {
        var qEl = acc.querySelector('.accordion__title') || acc.querySelector('summary');
        var aEl = acc.querySelector('.accordion__content');
        if (!qEl || !aEl) return;
        var question = qEl.textContent.trim();
        var answer = aEl.innerHTML.trim();
        if (question) items.push({ q: question, a: answer });
      });
      if (items.length) groups.push({ heading: heading, items: items });
    });
    return groups;
  }

  function buildFaqItem(question, answerHtml) {
    var details = document.createElement('details');
    details.className = 'exco-faq';

    var summary = document.createElement('summary');
    summary.className = 'exco-faq__q';
    var qSpan = document.createElement('span');
    qSpan.textContent = question;
    var caret = document.createElement('span');
    caret.className = 'exco-faq__caret';
    caret.innerHTML = CARET_SVG;
    summary.appendChild(qSpan);
    summary.appendChild(caret);

    var answer = document.createElement('div');
    answer.className = 'exco-faq__a rte';
    answer.innerHTML = answerHtml;

    details.appendChild(summary);
    details.appendChild(answer);
    return details;
  }

  /* --- Artikelnummer (SKU) live aktualisieren ------------------------------ */
  function updateSku(sku) {
    if (!portal) return;
    var row = qs('[data-exco-sku-row]', portal);
    var value = qs('[data-exco-sku]', portal);
    var clean = (sku == null ? '' : String(sku)).trim();
    if (value) value.textContent = clean;
    if (row) {
      if (clean) row.removeAttribute('hidden');
      else row.setAttribute('hidden', '');
    }
  }

  function initSkuSync() {
    var events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
    var sub = typeof subscribe !== 'undefined' ? subscribe : window.subscribe;
    if (!events || !events.variantChange || typeof sub !== 'function') return;
    sub(events.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant) {
        updateSku('');
        return;
      }
      var sku = variant.sku;
      if ((sku == null || sku === '') && config.skuMap) {
        sku = config.skuMap[String(variant.id)];
      }
      updateSku(sku);
    });
  }

  /* --- Feedback ------------------------------------------------------------ */
  function setStatus(el, message, kind) {
    if (!el) return;
    el.textContent = message;
    el.className = 'exco-fb__status' + (kind ? ' exco-fb__status--' + kind : '');
  }

  function handleFeedbackSubmit(form) {
    var status = form.querySelector('[data-exco-fb-status]');
    var fields = form.querySelector('.exco-fb__fields');
    var textarea = form.querySelector('[name="feedback"]');
    var submit = form.querySelector('[type="submit"]');
    var text = textarea ? textarea.value.trim() : '';

    if (!text) {
      setStatus(status, 'Bitte gib zuerst dein Feedback ein.', 'error');
      if (textarea) textarea.focus();
      return;
    }
    if (!config.feedbackEndpoint) {
      setStatus(status, 'Das Feedback-Formular ist noch nicht eingerichtet.', 'error');
      return;
    }

    var data = new FormData();
    data.append('feedback', text);
    var category = form.querySelector('[name="category"]:checked');
    data.append('category', category ? category.value : '');
    data.append('product_title', config.productTitle || '');
    var skuEl = qs('[data-exco-sku]', portal);
    data.append('sku', skuEl ? skuEl.textContent.trim() : '');
    data.append('url', window.location.href);

    if (submit) submit.disabled = true;
    setStatus(status, 'Wird gesendet …', 'pending');

    fetch(config.feedbackEndpoint, { method: 'POST', mode: 'no-cors', body: data })
      .then(function () {
        if (fields) fields.hidden = true;
        setStatus(status, 'Danke! Dein Feedback wurde übermittelt.', 'success');
        form.reset();
      })
      .catch(function () {
        if (submit) submit.disabled = false;
        setStatus(status, 'Senden fehlgeschlagen. Bitte versuche es später erneut.', 'error');
      });
  }

  /* --- Globale Event-Verdrahtung (einmalig, delegiert) --------------------- */
  function wireGlobal() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      // Häufigster Fall (Slider geschlossen): nur die Öffnen-Karte prüfen.
      var opener = e.target.closest('[data-exco-open]');
      if (opener) {
        e.preventDefault();
        openDrawer();
        return;
      }
      // Chat-/Schließen-Treffer können nur bei offenem Slider auftreten.
      if (!isOpen()) return;
      var chatTrigger = e.target.closest('[data-exco-chat]');
      if (chatTrigger) {
        e.preventDefault();
        closeDrawer();
        openChat();
        return;
      }
      var closer = e.target.closest('[data-exco-close]');
      if (closer && portal && portal.contains(closer)) {
        e.preventDefault();
        closeDrawer();
      }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-exco-feedback]');
      if (!form) return;
      e.preventDefault();
      handleFeedbackSubmit(form);
    });
  }

  /* --- Init ---------------------------------------------------------------- */
  function init() {
    readConfig();
    portal = buildPortal();
    faqLoaded = false;
    if (!portal) return;
    if (!wired) {
      wireGlobal();
      wired = true;
    }
    if (!skuSynced) {
      initSkuSync();
      skuSynced = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* --- Theme-Editor -------------------------------------------------------- */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#ExpertConsultationTemplate')) {
      var wasOpen = isOpen();
      init();
      if (wasOpen) openDrawer();
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-exco-config]')) {
      closeDrawer();
      var node = document.getElementById(PORTAL_ID);
      if (node) node.remove();
      portal = null;
    }
  });
})();